import React, { useState } from "react";
import { Grid, Box, Typography } from "@mui/material";
import { useFormikContext, FieldArray, getIn } from "formik";
// components
import { renderFormControl } from "components/FormManage/index";
// direct import
import "../../member.scss";
import AddOnManager from "./add-on";
import Summary from "../summary/summary";
import { formAddOns } from "../../helper";

const CreateForm = ({ ledgers, loading }) => {
  const formik = useFormikContext();
  const { values, setFieldValue } = useFormikContext();
  // state
  const [activeTab, setActiveTab] = useState(0);

  const getOpenAmountChecked =
    getIn(values, `addOns[${activeTab}].openAmount`) || false;
  const isRequires = getIn(values, `addOns[${activeTab}].isRequired`) || false;
  const isOpenAmount =
    getIn(values, `addOns`)?.some((el) => el?.openAmount) || false;

  const handleAction = (e) => {
    if (e?.target?.checked) {
      setFieldValue(`addOns[${activeTab}].amount`, 0);
    } else {
      setFieldValue(`addOns[${activeTab}].amount`, '');
    }
  };

  const handleChange = (data) => {
    setFieldValue(
      `addOns[${activeTab}].tax_deductible`,
      data?.amount_detuctible ?? 0
    );
    setFieldValue(`addOns[${activeTab}].tax_type`, data?.deductibleType ?? "%");
  };

  return (
    <Grid container>
      <Grid item sm={12} md={8}>
        <Box className="info_title">
          <h2>Add-Ons</h2>
          <p>Please complete the details below</p>

          <Box sx={{ mt: 5 }}>
            <FieldArray
              name="addOns"
              render={(arrayHelpers) => (
                <Grid container spacing={2}>
                  <Grid item sm={12} md={3}>
                    <Box className="cost_info_left_side">
                      <Box className="cost_info_title">
                        <AddOnManager
                          values={values ?? {}}
                          arrayHelpers={arrayHelpers ?? {}}
                          activeTab={activeTab}
                          setActiveTab={setActiveTab}
                          formik={formik ?? {}}
                        />
                      </Box>
                    </Box>
                  </Grid>

                  {(values?.addOns?.length > 0) && <Grid item sm={12} md={9}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Typography variant="h2" className="title_main">
                          {values?.addOns?.[activeTab]?.title}
                        </Typography>
                      </Grid>
                      {formAddOns(
                        activeTab,
                        ledgers,
                        loading,
                        handleAction,
                        getOpenAmountChecked,
                        isRequires,
                        isOpenAmount,
                        handleChange
                      )?.map((item, index) => (
                        <Grid
                          item
                          xs={12}
                          md={item?.grid ?? 6}
                          key={index}
                          sx={{ mb: 2 }}
                        >
                          {item?.type === "br" ? (
                            <Box
                              sx={{
                                width: "100%",
                                borderBottom: "1px solid #002e5c17",
                                height: "1px",
                                mx: "auto",
                              }}
                            />
                          ) : (
                            renderFormControl(item)
                          )}
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>}
                </Grid>
              )}
            />
          </Box>
        </Box>
      </Grid>
      <Grid item sm={12} md={4}>
        <Box className="class__summary">
          <Summary showRenewal={true} addOns={true} />
        </Box>
      </Grid>
    </Grid>
  );
};

export default CreateForm;
